<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />

      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">card_giftcard</v-icon>
          <span class="headline ml-2 white--text">Benefits</span>
          <v-spacer />
          <v-btn
            depressed
            @click="addCustom"
            class="action white--text rounded-sm"
            >add</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <span class="ml-3">These benefits will be displayed to all employees under "My benefits"</span>
          <v-col cols="12" v-if="benefits">
            <template v-for="(item, i) in benefits">
              <v-card :key="i" class="white--text my-5 action">
                <v-row>
                  <v-col cols="2">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-icon x-large color="white">
                        {{
                          item.category.toLowerCase() === 'insurance'
                              ? 'medical_services'
                              : item.category.toLowerCase() === 'pension'
                              ? 'money'
                              : 'shuffle'
                        }}
                      </v-icon>
                    </v-row>
                  </v-col>
                  <v-col cols="10">
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">
                          {{ item.name }}
                          <br />
                          <small>({{ item.category }})</small>
                        </div>
                        <div>{{ item.description }}</div>
                      </div>
                      <v-spacer />
                      <v-btn
                        @click="editEntity(item)"
                        depressed
                        class="theme-text rounded-sm"
                        >Edit</v-btn
                      >
                    </v-card-title>
                  </v-col>
                </v-row>
              </v-card>
            </template>
            <div class="text-center mt-8">
              <v-btn
                fab
                small
                class="theme white--text"
                depressed
                @click="previous"
                :disabled="pagination.page <= 0"
              >
                <v-icon small>navigate_before</v-icon>
              </v-btn>
              <span class="px-6">{{ pagination.page + 1 }}</span>
              <v-btn
                fab
                small
                depressed
                class="white--text theme"
                @click="next"
                :disabled="pagination.disableNext"
              >
                <v-icon small>navigate_next</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-row>
        <v-col lg="3">
          <v-card height="250px">
            <v-card-title>
              <span class="title font-weight-regular theme-text">Pension plans</span>
            </v-card-title>
            <v-card-text class="pt-0">
              <span class="subheading">Why does pension matter?</span>
              <div class="grey--text text--darken-1 mt-1">
                If you have employees you need to offer a pension plan. This can
                be a great benefit. We've done it easy to understand.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  small
                  depressed
                  class="action rounded-sm white--text ml-2 mt-n2"
                  @click="addPension"
              >Add Pension
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col lg="3">
          <v-card height="250px">
            <v-card-title>
              <span class="title font-weight-regular theme-text">Insurance plans</span>
            </v-card-title>
            <v-card-text class="pt-0">
              <div class="grey--text text--darken-1">
                If you have an insurance plan for your employees you can add
                them here or select a provider from one of our offerings.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                small
                depressed
                class="action rounded-sm white--text ml-2 mt-5"
                @click="addInsurance"
                >Add Insurance</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col lg="3">
          <v-card height="250px">
            <v-card-title>
              <span class="title font-weight-regular theme-text"
              >Custom benefits</span
              >
            </v-card-title>
            <v-card-text class="pt-0">
              <div class="grey--text text--darken-1">
                If you have an existing benefits, you can add them here so that
                your employees can view them.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                @click="addCustom"
                small
                depressed
                class="action rounded-sm white--text ml-2 mt-10"
              >Add Benefits</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col lg="3">
          <v-card height="250px">
            <v-card-title>
              <span class="title font-weight-regular theme-text"
              >View marketplace</span
              >
            </v-card-title>
            <v-card-text class="pt-0">
              <div class="grey--text text--darken-1">
                You can browse our exclusive marketplace to find benefits that
                suit your needs.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn
                small
                depressed
                class="action rounded-sm white--text ml-2 mt-15"
                @click="benefitMarketPlace"
                >Search marketplace</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>
<script>
import {mapGetters}   from 'vuex';

import {Actions}      from '@/views/actions';
import {Breadcrumbs}  from '@/views/breadcrumbs';
import {Component}    from '@/views/component';
import {Constants}    from '@/views/constants';
import {TableHeaders} from '@/views/headers';

export default {
  name: Component.Protected.Benefit.List,
  computed: {
    ...mapGetters(['userInfo']),
  },
  data: () => ({
    breadcrumbs: Breadcrumbs.Benefit.List,
    tableHeaders: TableHeaders.Benefits.List,
    pagination: {disableNext: true, page: 0},
    search: {type: '', limit: 5, offset: 0},
    benefits: [],
  }),
  methods: {
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.benefits.length === this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getBenefits();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getBenefits();
      }
    },
    view(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Benefit.OnBoarding,
        params: { id: id },
      });
    },
    benefitMarketPlace() {
      this.$router.push({ name: Component.Protected.Benefit.Marketplace });
    },
    addPension() {
      this.$router.push({ name: Component.Protected.Benefit.Pension.Add });
    },
    addInsurance() {
      this.$router.push({ name: Component.Protected.Benefit.Insurance.Add });
    },
    addCustom() {
      this.$router.push({ name: Component.Protected.Benefit.Custom.Add });
    },
   
    editEntity(item) {
      if (this.userInfo.role !== Constants.Roles.HR || !item || !item.id) {
        return false;
      }

      switch (item.category) {
        case Constants.Benefits.Category.Pension:
          this.$router.push({
            name: Component.Protected.Benefit.Pension.Edit,
            params: { id: item.id },
          });
          break;
        case Constants.Benefits.Category.Insurance:
          this.$router.push({
            name: Component.Protected.Benefit.Insurance.Edit,
            params: { id: item.id },
          });
          break;
        default:
          this.$router.push({
            name: Component.Protected.Benefit.Custom.Edit,
            params: { id: item.id },
          });
          break;
      }
    },
    getBenefits() {
      this.$store.dispatch(Actions.Benefits.Find, this.search).then(r => {
        if (r.status === 200) {
          if (!r.data) {
            this.pagination.disableNext = true;
            return false;
          }
          let len = r.data.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
          this.benefits = r.data;
        }
      })
        .catch((err) => {
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Find;
          console.error(Constants.Benefits.Messages.Error.Find, err);
        });
    },
    createBenefit() {
      this.$router.push({ name: Component.Protected.Benefit.Add });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.getBenefits();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.getBenefits());
    }
  },
};
</script>
